export const CsvExportEndpoint = {
  RUN_CSV_EXPORT: '/default/csv-export/create-csv',
  LOAD_DEVICES: '/default/csv-export/load-devices',
  LOAD_AVAILABLE_SYSTEMS: '/default/csv-export/load-available-systems',
  LOAD_DEVICES_FOR_SYSTEMS: '/default/csv-export/load-devices-for-systems',
  LOAD_CSV_EXPORTS: '/default/csv-export/load-exports',
  LOAD_CSV_EXPORT_CONFIG: '/default/csv-export/load-config',
  SAVE_CSV_EXPORT_CONFIG: '/default/csv-export/save-config',
  DELETE_CSV_EXPORT: '/default/csv-export/delete-export',
  LOAD_CSV_REPORT_TRANSMISSION: '/default/csv-export/load-report-transmission',
  UPDATE_CSV_REPORT_TRANSMISSION: '/default/csv-export/update-report-transmission',
  DELETE_CSV_REPORT_TRANSMISSION: '/default/csv-export/delete-report-transmission',
};
